export default __webpack_public_path__ + "static/media/bg-top.201e9960.png";